export const ANALYTICS_LIST_IDS = ['driver-km', 'customers', 'companies', 'requests', 'quotes', 'ads'];
function queryString(q) {
    const p = new URLSearchParams();
    const put = (k, v) => {
        if (v === undefined || v === null || v === '')
            return;
        if (Array.isArray(v)) {
            if (v.length > 0)
                p.set(k, v.join(','));
            return;
        }
        if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean')
            p.set(k, String(v));
    };
    for (const [k, v] of Object.entries(q))
        put(k, v);
    return p.toString();
}
export class AnalyticsListsApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** One page of a list (`analytics:view`; customers and requests also need `analytics:view_personal`, names need it plus `personal: true`). */
    list(list, query = {}) {
        const qs = queryString(query);
        return this.client.request({ method: 'GET', path: `/v1/analytics/lists/${list}${qs === '' ? '' : `?${qs}`}`, auth: true });
    }
    /** The list as CSV text (UTF-8 with a BOM). Needs `analytics:export`; at most 20 000 rows (413 beyond). `part: 'summary'` (driver-km) is the per-market header. */
    exportCsv(list, query = {}, options = {}) {
        const { limit: _limit, offset: _offset, ...body } = query;
        return this.client.request({ method: 'POST', path: `/v1/analytics/lists/${list}/export`, body: { ...body, ...options }, auth: true, expect: 'text' });
    }
}
export class AccessReportApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** A page of sessions, newest first (`access:audit`, admins only; a country grant sees its own countries). */
    sessions(query = {}) {
        const p = new URLSearchParams();
        for (const [k, v] of Object.entries(query)) {
            if (v === undefined || v === '')
                continue;
            if (Array.isArray(v))
                p.set(k, v.join(','));
            else if (typeof v === 'string' || typeof v === 'number')
                p.set(k, String(v));
        }
        const qs = p.toString();
        return this.client.request({ method: 'GET', path: `/v1/ops/access/sessions${qs === '' ? '' : `?${qs}`}`, auth: true });
    }
    /** The same rows as CSV (needs `access:audit` and `analytics:export`); at most 20 000, 413 beyond. */
    exportCsv(query = {}, options = {}) {
        return this.client.request({ method: 'POST', path: '/v1/ops/access/sessions/export', body: { ...query, ...options }, auth: true, expect: 'text' });
    }
}
//# sourceMappingURL=orphan-reports.js.map